import axios from "axios";
import { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddEditAssetType from "../../../components/AssetAndAttribute/AddEditAssetType";
import MapAssetAttributeModal from "../../../components/AssetAndAttribute/MapAssetAttributeModal";

function AssetTypePage() {
  const [assets, setAssets] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState("create");
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [openMapModal, setOpenMapModal] = useState(false);
    const [selectedAssetType, setSelectedAssetType] = useState(null);

    const openMap = (row) => {
    setSelectedAssetType(row);
    setOpenMapModal(true);
    };

  const fetchAssets = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/assets-type`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setAssets(res.data.response || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load asset types");
    }
  };

  useEffect(() => {
    fetchAssets();
  }, []);

  const handleAdd = () => {
    setMode("create");
    setSelectedAsset(null);
    setOpenModal(true);
  };

  const handleEdit = (row) => {
    setMode("edit");
    setSelectedAsset({
      identy: row.identy,
      typeCode: row.typeCode,
      typeName: row.typeName,
      notes: row.notes,
      imagePath: row.imagePath,
    });
    setOpenModal(true);
  };

 const handleDelete = async (identy) => {
  if (!window.confirm("Are you sure you want to delete this asset type?")) return;

  try {
    const token = sessionStorage.getItem("token");

    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/assets-type/${identy}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    alert("Asset deleted successfully");
    fetchAssets(); // refresh table
  } catch (err) {
    console.error(err);

    if (err?.response?.status === 403) {
      alert(err.response.data.message || "Deletion not allowed");
    } else {
      alert("Delete failed");
    }
  }
};

  return (
    <div
      className="container-fluid"
      style={{
        height: "100%",
        borderRadius: "20px",
        overflow: "hidden",
      }}
    >
      {/* Top Controls */}
      <div className="d-flex justify-content-between align-items-center flex-wrap p-3">
        <h2 className="ms-1 mb-3">Asset Types</h2>

        <button className="btn btn-primary mb-3" onClick={handleAdd}>
          + Add Asset Type
        </button>
      </div>

      {/* Scrollable Table Container */}
      <div style={{ maxHeight: "60vh", overflowY: "auto" }} className="px-3">
        <table className="table table-bordered table-hover shadow-sm">
          <thead className="table-primary">
            <tr>
              <th
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#0D59A7",
                  color: "white",
                  zIndex: 1,
                }}
              >
                Type Code
              </th>

              <th
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#0D59A7",
                  color: "white",
                  zIndex: 1,
                }}
              >
                Type Name
              </th>

              <th
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#0D59A7",
                  color: "white",
                  zIndex: 1,
                }}
              >
                Notes
              </th>

              <th
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#0D59A7",
                  color: "white",
                  zIndex: 1,
                }}
              >
                Created Date
              </th>

              <th
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#0D59A7",
                  color: "white",
                  zIndex: 1,
                }}
              >
                Action
              </th>

              <th
                style={{
                    position: "sticky",
                    top: 0,
                    background: "#0D59A7",
                    color: "white",
                    zIndex: 1,
                }}
                >
                Map Attribute
                </th>
            </tr>
          </thead>

          <tbody>
            {assets.length > 0 ? (
              assets.map((a) => (
                <tr key={a.identy}>
                  <td>{a.typeCode}</td>
                  <td className="text-capitalize">{a.typeName}</td>
                  <td style={{ maxWidth: 200 }}>
                    <span
                        title={a.notes || ""}
                        style={{
                        display: "inline-block",
                        maxWidth: 200,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        verticalAlign: "middle",
                        cursor: a.notes && a.notes.length > 25 ? "pointer" : "default",
                        }}
                    >
                        {a.notes && a.notes.length > 25
                        ? a.notes.slice(0, 25) + "..."
                        : a.notes || "-"}
                    </span>
                    </td>
                  <td>{a.createdDate}</td>
                  <td style={{ textAlign: "center" }}>
                    <EditIcon
                      style={{
                        cursor: "pointer",
                        color: "#1976d2",
                        marginRight: "10px",
                      }}
                      onClick={() => handleEdit(a)}
                    />
                    <DeleteIcon
                      style={{ cursor: "pointer", color: "#d32f2f" }}
                      onClick={() => handleDelete(a.identy)}
                    />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => openMap(a)}
                    >
                        Map Attribute
                    </button>
                    </td>
             </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No asset types found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      <AddEditAssetType
        open={openModal}
        mode={mode}
        initialData={selectedAsset}
        onClose={() => {
          setOpenModal(false);
          fetchAssets();
        }}
      />

      <MapAssetAttributeModal
        open={openMapModal}
        assetType={selectedAssetType}
        onClose={() => setOpenMapModal(false)}
        />
    </div>
  );
}

export default AssetTypePage;